/**
 * Setup Guard Component
 * Redirects to setup page if initial setup is needed
 */

import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { apiClient } from '../../lib/api'

export function SetupGuard() {
  const [needsSetup, setNeedsSetup] = useState<boolean | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    async function checkSetup() {
      try {
        const response = await apiClient.get<{ needsSetup: boolean }>(
          '/auth/check-setup'
        )
        if (response.success && response.data) {
          setNeedsSetup(response.data.needsSetup)
        }
      } catch (error) {
        console.error('Failed to check setup status:', error)
        setNeedsSetup(false)
      } finally {
        setIsLoading(false)
      }
    }

    checkSetup()
  }, [])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-ink-muted">Checking setup status...</p>
        </div>
      </div>
    )
  }

  if (needsSetup) {
    return <Navigate to="/setup" replace />
  }

  return <Outlet />
}
